import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#667085",
      d: "M6.65 5.983a2.333 2.333 0 1 0-3.3 0L5 7.633zM5 9.518 2.407 6.925a3.667 3.667 0 1 1 5.185 0zm0-4.185a1 1 0 1 1 0-2 1 1 0 0 1 0 2m6 8.3 1.65-1.65a2.333 2.333 0 1 0-3.3 0zm2.592-.708L11 15.518l-2.593-2.593a3.667 3.667 0 1 1 5.185 0M11 11.333a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
    }, null, -1)
  ]))]))
}
export default { render: render }